import { BarekamIcon, IconVariants } from "../../../../components/icon/barekam-icon";
import BarekamButton, { OrderButtons, SimpleButtons } from "../../../../components/button";
import { FilterOpened } from "../styled";
import { Message, MessageSections } from "../../../../components/message/message";
import CustomerStatusFilter from "./blocks/customer-status-filter/customer-status-filter";
import React from "react";
import { UserStatuses, UserStatusModel } from "../../../../shared/models/user/user-status";
import BarekamText from "../../../../components/text";
import { AttachmentIcons } from "../../../../components/icon/variants";
import { ManagementPageType } from "../../../../../management-pages/user-order-management/management-data-container";
import { OrderStateModel, OrderStates } from "../../../../shared/models/order/order-status";

export const CustomerFilter = ({ filter, setFilter, exportFunction, filterType }: CustomerFilterProps) => {
    function handleStatusFilterChange(userStatus: UserStatusModel | undefined) {
        const filterClone = { ...filter } as CustomerFilterModel;
        if (userStatus) {
            filterClone.status = userStatus.userStatusId;
        } else {
            delete filterClone.status;
        }

        setFilter(filterClone);
    }

    function handleOrdertatusFilterChange(orderStatus: OrderStateModel | undefined) {
        const filterClone = { ...filter } as OrderFilterModel;
        
        if (orderStatus) {
            filterClone.state = orderStatus.state;
        } else {
            delete filterClone.state;
        }

        setFilter(filterClone);
    }


    function resetFilter() {
        setFilter({});
    }

    const FilterResetButton = () => {
        return (
            <BarekamButton type={SimpleButtons.LINK} onClick={() => resetFilter()}>
                <BarekamIcon variant={IconVariants.reset} />

                <BarekamText variant={'m'} bold color={'#A9A9C2'}>
                    <Message messageKey={"reset"} sectionId={MessageSections.ORDERS} />
                </BarekamText>
            </BarekamButton>
        )
    }

    const FilterContent = () => {
        return (
            <>
                {filterType === ManagementPageType.MOBILE_ORDERS ? (
                    <CustomerStatusFilter selectedStatusId={(filter as OrderFilterModel).state}
                        orderStatuses={OrderStates}
                        onOrderFilterChange={handleOrdertatusFilterChange} filterType={filterType} />
                ) : (
                    <CustomerStatusFilter selectedStatusId={(filter as CustomerFilterModel).status}
                        userStatuses={UserStatuses}
                        onFilterChange={handleStatusFilterChange} />
                )}

                {Object.keys(filter).length > 0
                    ? <>
                        {exportFunction ?
                            <BarekamButton type={OrderButtons.EXPORT} size={"s"} onClick={exportFunction}>
                                <BarekamIcon variant={AttachmentIcons.download} />

                                <BarekamText variant={"m"} bold>
                                    <Message messageKey={"export"} sectionId={MessageSections.ORDERS} />
                                </BarekamText>
                            </BarekamButton>
                            : ''
                        }

                        <FilterResetButton />
                    </>
                    : ''
                }
            </>
        )
    }

    return (
        <FilterOpened>
            <FilterContent />
        </FilterOpened>
    )
}

export interface CustomerFilterModel {
    status?: number,
    userGroup?: number,
    textQuery?: string
}

export interface OrderFilterModel {
    state?: string,
    userGroup?: number,
    textQuery?: string
}

interface CustomerFilterProps {
    filter: CustomerFilterModel | OrderFilterModel,
    setFilter: (filter: CustomerFilterModel) => void;
    exportFunction?: () => Promise<void>;
    filterType?: ManagementPageType.CUSTOMERS | ManagementPageType.MOBILE_USER | ManagementPageType.MOBILE_ORDERS
}